import { reactive } from "@vue/composition-api";
import { AutocompleteResult } from "@/components/Autocomplete/autocomplete-id";

import { LotUnit } from "@/store/modules/lotUnits";

interface hasLotUnitId {
  lotUnitId?: string;
  lot_unit_id?: string;
}

export const enum LotUnitStatus {
  active = "active",
  archived = "archived",
}

const prettifiedLotUnitStatus = {
  active: "Active",
  archived: "Archived",
};

export const prettifyLotUnitStatus = (s: LotUnitStatus) => {
  return prettifiedLotUnitStatus[s];
};

export const lotUnitStatusReverseLookup = <{ [key: string]: LotUnitStatus }>{
  active: LotUnitStatus.active,
  archived: LotUnitStatus.archived,
};

export interface FormLotUnit {
  id: string;
  name: string;
  description: string;
  status: string;
}

export function buildFormLotUnit() {
  const formLotUnit = reactive<FormLotUnit>({
    id: "",
    name: "",
    description: "",
    status: LotUnitStatus.active,
  });

  const loadLotUnitIntoForm = (lt: LotUnit, flu: FormLotUnit) => {
    flu.id = lt.id;
    flu.name = lt.name;
    flu.description = lt.description;
    flu.status = lt.status;
  };

  const lotUnitStatuses = reactive<LotUnitStatus[]>([]);

  const loadLotUnitStatusesIntoForm = (ltStatuses: LotUnitStatus[]) => {
    ltStatuses.push(LotUnitStatus.active, LotUnitStatus.archived);
  };

  return {
    formLotUnit,
    loadLotUnitIntoForm,
    lotUnitStatuses,
    loadLotUnitStatusesIntoForm,
  };
}

export function buildFormLotUnitAutocomplete() {
  let formLotUnit = () => {
    return reactive<AutocompleteResult>({
      id: "",
      label: "",
    });
  };

  let updateLotUnit = (
    evt: AutocompleteResult,
    formLotUnit: AutocompleteResult,
    formData: any,
    formDataKey = "lotUnitId",
  ) => {
    formLotUnit.id = evt.id;
    formLotUnit.label = evt.label;

    if (formData.hasOwnProperty(formDataKey)) {
      formData[formDataKey] = evt.id;
    }
  };

  return {
    formLotUnit,
    updateLotUnit,
  };
}
